import {
  FETCH_TIME_ENTRIES, FETCH_TIME_ENTRIES_SUCCESS, FETCH_TIME_ENTRIES_FAIL,
  START_TIME_ENTRY, START_TIME_ENTRY_SUCCESS, START_TIME_ENTRY_FAIL,
  STOP_TIME_ENTRY, STOP_TIME_ENTRY_SUCCESS, STOP_TIME_ENTRY_FAIL,
  ADD_MANUAL_TIME_ENTRY, ADD_MANUAL_TIME_ENTRY_SUCCESS, ADD_MANUAL_TIME_ENTRY_FAIL,
  UPDATE_TIME_ENTRY, UPDATE_TIME_ENTRY_SUCCESS, UPDATE_TIME_ENTRY_FAIL,
  DELETE_TIME_ENTRY, DELETE_TIME_ENTRY_SUCCESS, DELETE_TIME_ENTRY_FAIL,
  CLEAR_TIME_ENTRY_MESSAGES,
  SET_USER_HOURLY_RATE, SET_USER_HOURLY_RATE_SUCCESS, SET_USER_HOURLY_RATE_FAIL,
} from './actionTypes';

const INIT_STATE = {
  entries: [],
  entriesLoading: false,
  entriesError: null,

  mutating: false,
  mutateError: null,
  mutateSuccess: null,

  rateSaving: false,
  rateError: null,
  rateSuccess: null,
};

const upsert = (list, entry) => {
  if (!entry) return list;
  const idx = list.findIndex((e) => e.id === entry.id);
  if (idx === -1) return [entry, ...list];
  const next = list.slice();
  next[idx] = entry;
  return next;
};

const TimeEntry = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_TIME_ENTRIES:
      return { ...state, entriesLoading: true, entriesError: null };
    case FETCH_TIME_ENTRIES_SUCCESS:
      return { ...state, entries: action.payload || [], entriesLoading: false };
    case FETCH_TIME_ENTRIES_FAIL:
      return { ...state, entriesLoading: false, entriesError: action.payload };

    case START_TIME_ENTRY:
    case STOP_TIME_ENTRY:
    case ADD_MANUAL_TIME_ENTRY:
    case UPDATE_TIME_ENTRY:
    case DELETE_TIME_ENTRY:
      return { ...state, mutating: true, mutateError: null, mutateSuccess: null };

    case START_TIME_ENTRY_SUCCESS:
    case STOP_TIME_ENTRY_SUCCESS:
    case ADD_MANUAL_TIME_ENTRY_SUCCESS:
    case UPDATE_TIME_ENTRY_SUCCESS:
      return {
        ...state,
        mutating: false,
        mutateSuccess: 'OK',
        entries: upsert(state.entries, action.payload),
      };

    case DELETE_TIME_ENTRY_SUCCESS:
      return {
        ...state,
        mutating: false,
        mutateSuccess: 'OK',
        entries: state.entries.filter((e) => e.id !== action.payload),
      };

    case START_TIME_ENTRY_FAIL:
    case STOP_TIME_ENTRY_FAIL:
    case ADD_MANUAL_TIME_ENTRY_FAIL:
    case UPDATE_TIME_ENTRY_FAIL:
    case DELETE_TIME_ENTRY_FAIL:
      return { ...state, mutating: false, mutateError: action.payload };

    case CLEAR_TIME_ENTRY_MESSAGES:
      return { ...state, mutateError: null, mutateSuccess: null, rateError: null, rateSuccess: null };

    case SET_USER_HOURLY_RATE:
      return { ...state, rateSaving: true, rateError: null, rateSuccess: null };
    case SET_USER_HOURLY_RATE_SUCCESS:
      return { ...state, rateSaving: false, rateSuccess: 'OK' };
    case SET_USER_HOURLY_RATE_FAIL:
      return { ...state, rateSaving: false, rateError: action.payload };

    default:
      return state;
  }
};

export default TimeEntry;
